import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { useParams, useHistory } from 'react-router-dom'
import { fetchCustomerApps, fetchApp } from '../store/actions/appAction'
import Customer from '../components/Customer'

import { Container, Typography, Grid, TextField, Divider, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
    },
    drawerHeader: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(0, 1),
      ...theme.mixins.toolbar,
      justifyContent: 'flex-end',
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      marginLeft: -drawerWidth,
    },
    contentShift: {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    },
  }));
 

const AppDetail = () => {
    const classes = useStyles();
    const dispatch = useDispatch()
    const history = useHistory()
    const {id} = useParams()
  
    useEffect(() => {
      dispatch(fetchCustomerApps(id))
      dispatch(fetchApp(id))
    }, [dispatch, id])
    
    const customers = useSelector(state => state.appReducer.customers)
    const app = useSelector(state => state.appReducer.app)

    const handleSocialLoginConfig = () => {
        history.push(`/app/${id}/socialLogin`)
    }

    const handleOtpLoginConfig = () => {
      history.push(`/app/${id}/otpLogin`)
    }

    return (
      <Container>
      <Typography component="h1" variant="h4" align="center" color="textPrimary" spacing={4} gutterBottom>
          {app.appName}
      </Typography>
      <Divider />
      <TextField
        variant="outlined"
        margin="normal"
        fullWidth
        name="apiKey"
        label="API KEY"
        id="apiKey"
        value={app.apiKey || ''}
        autoFocus
      />
      <Divider />
      <Button
          fullWidth
          variant="contained"
          color="secondary"
          onClick={handleSocialLoginConfig}
          >
          Social Login Configuration
      </Button>
      <Button
          fullWidth
          variant="contained"
          color="primary"
          onClick={handleOtpLoginConfig}
          >
          Otp Login Configuration
      </Button>
      <Typography mt={8} className={classes.title} color="textSecondary" gutterBottom>
        List Customer Signed In
      </Typography>
      <div>
        {
          customers.map(customer => {
            return (
              <Customer key={customer._id} customer={customer}/>
            )
          })
        }
      </div>
    </Container>
    )
}

export default AppDetail
